/**
 * Trioprint Ausmalbild-Generator
 * Lokale Bildverarbeitung im Browser - keine Server-Uploads
 */
(function () {
  'use strict';

  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
  const MAX_DIMENSION = 1400;
  const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

  function initColoringGenerator(root) {
    const els = {
      upload:       root.querySelector('[data-coloring-upload]'),
      dropzone:     root.querySelector('[data-coloring-dropzone]'),
      original:     root.querySelector('[data-coloring-original]'),
      result:       root.querySelector('[data-coloring-result]'),
      detail:       root.querySelector('[data-coloring-detail]'),
      detailVal:    root.querySelector('[data-coloring-detail-value]'),
      generateBtn:  root.querySelector('[data-coloring-generate]'),
      downloadBtn:  root.querySelector('[data-coloring-download]'),
      resetBtn:     root.querySelector('[data-coloring-reset]'),
      message:      root.querySelector('[data-coloring-message]'),
      workspace:    root.querySelector('[data-coloring-workspace]')
    };

    let originalImage = null;
    let hasResult = false;
    let debounceTimer = null;

    els.upload.addEventListener('change', (e) => {
      if (e.target.files && e.target.files[0]) handleImageUpload(e.target.files[0]);
    });
    els.generateBtn.addEventListener('click', generateColoringImage);
    els.downloadBtn.addEventListener('click', downloadPdf);
    els.resetBtn.addEventListener('click', resetGenerator);

    els.detail.addEventListener('input', () => {
      els.detailVal.textContent = els.detail.value;
      // Live-Vorschau leicht debounced, damit Slider flüssig bleibt
      if (originalImage) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(generateColoringImage, 120);
      }
    });

    // ===== Drag & Drop =====

    const dropzone = els.dropzone
      || els.upload.closest('label')
      || els.upload.parentElement
      || root;

    // dragleave feuert auch beim Wechsel auf Kindelemente -> Zähler verhindert Flackern
    let dragDepth = 0;

    function dragHasFiles(e) {
      const dt = e.dataTransfer;
      if (!dt || !dt.types) return false;
      return Array.prototype.indexOf.call(dt.types, 'Files') !== -1;
    }

    function setDragState(active) {
      dropzone.classList.toggle('is-dragover', active);
    }

    dropzone.addEventListener('dragenter', (e) => {
      if (!dragHasFiles(e)) return;
      e.preventDefault();
      dragDepth++;
      setDragState(true);
    });

    // Ohne preventDefault() auf dragover feuert 'drop' nie
    dropzone.addEventListener('dragover', (e) => {
      if (!dragHasFiles(e)) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      setDragState(true);
    });

    dropzone.addEventListener('dragleave', () => {
      dragDepth = Math.max(0, dragDepth - 1);
      if (dragDepth === 0) setDragState(false);
    });

    dropzone.addEventListener('drop', (e) => {
      e.preventDefault();
      e.stopPropagation();
      dragDepth = 0;
      setDragState(false);

      const file = extractFile(e.dataTransfer);
      if (!file) {
        showMessage('Keine Datei erkannt. Bitte ziehe eine JPG-, PNG- oder WebP-Datei auf das Feld.', 'error');
        return;
      }
      syncInputFiles(file);
      handleImageUpload(file);
    });

    function extractFile(dt) {
      if (!dt) return null;
      if (dt.files && dt.files.length) return dt.files[0];
      if (dt.items && dt.items.length) {
        for (let i = 0; i < dt.items.length; i++) {
          if (dt.items[i].kind === 'file') return dt.items[i].getAsFile();
        }
      }
      return null;
    }

    function syncInputFiles(file) {
      // Input-Wert mitziehen, damit Reset und erneutes Auswählen konsistent bleiben
      try {
        const dt = new DataTransfer();
        dt.items.add(file);
        els.upload.files = dt.files;
      } catch (err) {
        // Ältere Safari-Versionen unterstützen das nicht - unkritisch
      }
    }

    // ===== Hilfsfunktionen =====

    function showMessage(text, type = 'info') {
      els.message.hidden = false;
      els.message.textContent = text;
      els.message.className = 'tp-coloring__message tp-coloring__message--' + type;
    }
    function clearMessage() { els.message.hidden = true; els.message.textContent = ''; }

    function handleImageUpload(file) {
      clearMessage();
      if (!ACCEPTED_TYPES.includes(file.type)) {
        showMessage('Ungültiger Dateityp. Bitte lade eine JPG-, PNG- oder WebP-Datei hoch.', 'error');
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        showMessage('Die Datei ist größer als 10 MB. Bitte wähle ein kleineres Bild.', 'error');
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          originalImage = img;
          drawImageToCanvas(img);
          els.workspace.hidden = false;
          els.downloadBtn.disabled = true;
          hasResult = false;
          showMessage('Bild geladen – das Ausmalbild wird erstellt …', 'info');
          generateColoringImage();
        };
        img.onerror = () => showMessage('Das Bild konnte nicht geladen werden. Bitte versuche eine andere Datei.', 'error');
        img.src = e.target.result;
      };
      reader.onerror = () => showMessage('Die Datei konnte nicht gelesen werden.', 'error');
      reader.readAsDataURL(file);
    }

    function drawImageToCanvas(img) {
      const canvas = els.original;
      const ctx = canvas.getContext('2d');
      let { width, height } = img;
      if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
        const ratio = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
      }
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
    }

    function generateColoringImage() {
      if (!originalImage) {
        showMessage('Bitte lade zuerst ein Bild hoch.', 'error');
        return;
      }
      clearMessage();

      const srcCanvas = els.original;
      const dstCanvas = els.result;
      dstCanvas.width = srcCanvas.width;
      dstCanvas.height = srcCanvas.height;

      const srcCtx = srcCanvas.getContext('2d');
      const dstCtx = dstCanvas.getContext('2d');

      // Skala 0–100: 50 = Standard. Niedrig = nur kräftige Konturen, hoch = mehr Details.
      const detail = parseInt(els.detail.value, 10);

      let imgData = srcCtx.getImageData(0, 0, srcCanvas.width, srcCanvas.height);

      // 1. Graustufen
      imgData = applyGrayscale(imgData);
      // 2. Auto-Kontrast (Histogramm-Stretch) → robuste Ergebnisse bei flauen Fotos
      imgData = applyAutoContrast(imgData);
      // 3. Gaußscher Blur (separierbar, schnell) → glättet Rauschen
      imgData = applyGaussianBlur(imgData, 1.2);
      // 4. Sobel-Kantenerkennung → liefert Kantenstärke
      const edges = applySobelMagnitude(imgData);
      // 5. Adaptive Schwellenwert-Bestimmung auf Basis Median + Detail-Slider
      const threshold = computeAdaptiveThreshold(edges, detail);
      // 6. Binarisieren: Kanten >= threshold → schwarz, sonst weiß
      let binary = binarize(edges, srcCanvas.width, srcCanvas.height, threshold);
      // 7. Einzelne schwarze Pixel entfernen (Salz-Rauschen)
      binary = removeIsolatedPixels(binary);
      // 8. Linien um 1 Pixel verdicken (immer, damit klar ausmalbar)
      binary = thickenLines(binary, 1);

      dstCtx.putImageData(binary, 0, 0);

      hasResult = true;
      els.downloadBtn.disabled = false;
      showMessage('Ausmalbild fertig – jetzt PDF herunterladen oder Detailgrad anpassen.', 'success');
    }

    // ===== Bildverarbeitung =====

    function applyGrayscale(imageData) {
      const d = imageData.data;
      for (let i = 0; i < d.length; i += 4) {
        const g = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
        d[i] = d[i + 1] = d[i + 2] = g;
      }
      return imageData;
    }

    function applyAutoContrast(imageData) {
      const d = imageData.data;
      // Histogramm berechnen
      const hist = new Uint32Array(256);
      for (let i = 0; i < d.length; i += 4) hist[d[i] | 0]++;
      const total = (d.length / 4);
      // 1% / 99% Perzentile als robuste Min/Max-Werte
      const lowCut = total * 0.01, highCut = total * 0.99;
      let cum = 0, min = 0, max = 255;
      for (let v = 0; v < 256; v++) { cum += hist[v]; if (cum >= lowCut) { min = v; break; } }
      cum = 0;
      for (let v = 0; v < 256; v++) { cum += hist[v]; if (cum >= highCut) { max = v; break; } }
      if (max <= min) return imageData;
      const scale = 255 / (max - min);
      for (let i = 0; i < d.length; i += 4) {
        const v = Math.max(0, Math.min(255, (d[i] - min) * scale));
        d[i] = d[i + 1] = d[i + 2] = v;
      }
      return imageData;
    }

    function applyGaussianBlur(imageData, sigma) {
      const { width, height, data } = imageData;
      // Gauß-Kernel erzeugen
      const radius = Math.max(1, Math.ceil(sigma * 3));
      const kernel = new Float32Array(radius * 2 + 1);
      let sum = 0;
      const s2 = 2 * sigma * sigma;
      for (let i = -radius; i <= radius; i++) {
        const v = Math.exp(-(i * i) / s2);
        kernel[i + radius] = v; sum += v;
      }
      for (let i = 0; i < kernel.length; i++) kernel[i] /= sum;

      const tmp = new Float32Array(width * height);
      const out = new Uint8ClampedArray(data.length);

      // Horizontal
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          let acc = 0;
          for (let k = -radius; k <= radius; k++) {
            const xi = Math.min(width - 1, Math.max(0, x + k));
            acc += data[(y * width + xi) * 4] * kernel[k + radius];
          }
          tmp[y * width + x] = acc;
        }
      }
      // Vertikal
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          let acc = 0;
          for (let k = -radius; k <= radius; k++) {
            const yi = Math.min(height - 1, Math.max(0, y + k));
            acc += tmp[yi * width + x] * kernel[k + radius];
          }
          const idx = (y * width + x) * 4;
          const v = acc;
          out[idx] = out[idx + 1] = out[idx + 2] = v;
          out[idx + 3] = 255;
        }
      }
      return new ImageData(out, width, height);
    }

    function applySobelMagnitude(imageData) {
      const { width, height, data } = imageData;
      const mag = new Float32Array(width * height);
      for (let y = 1; y < height - 1; y++) {
        for (let x = 1; x < width - 1; x++) {
          const i00 = ((y - 1) * width + (x - 1)) * 4;
          const i01 = ((y - 1) * width + x) * 4;
          const i02 = ((y - 1) * width + (x + 1)) * 4;
          const i10 = (y * width + (x - 1)) * 4;
          const i12 = (y * width + (x + 1)) * 4;
          const i20 = ((y + 1) * width + (x - 1)) * 4;
          const i21 = ((y + 1) * width + x) * 4;
          const i22 = ((y + 1) * width + (x + 1)) * 4;
          const gx = -data[i00] + data[i02] - 2*data[i10] + 2*data[i12] - data[i20] + data[i22];
          const gy = -data[i00] - 2*data[i01] - data[i02] + data[i20] + 2*data[i21] + data[i22];
          mag[y * width + x] = Math.sqrt(gx * gx + gy * gy);
        }
      }
      return { width, height, mag };
    }

    function computeAdaptiveThreshold(edges, detail) {
      // Sammle nicht-null Kantenwerte, bestimme Median als Basis
      const { mag } = edges;
      const sample = [];
      // Stichprobe von ~10000 Pixeln (Performance)
      const step = Math.max(1, Math.floor(mag.length / 10000));
      for (let i = 0; i < mag.length; i += step) {
        if (mag[i] > 5) sample.push(mag[i]);
      }
      if (sample.length === 0) return 50;
      sample.sort((a, b) => a - b);
      const median = sample[Math.floor(sample.length * 0.5)];
      // detail: 0 = sehr wenige Linien (hoher Threshold), 100 = viele (niedriger Threshold)
      // Threshold zwischen ~2.0x Median (wenig) und ~0.4x Median (viel)
      const factor = 2.0 - (detail / 100) * 1.6;
      return Math.max(15, median * factor);
    }

    function binarize(edges, width, height, threshold) {
      const { mag } = edges;
      const out = new Uint8ClampedArray(width * height * 4);
      for (let i = 0; i < mag.length; i++) {
        const v = mag[i] >= threshold ? 0 : 255;
        const idx = i * 4;
        out[idx] = out[idx + 1] = out[idx + 2] = v;
        out[idx + 3] = 255;
      }
      return new ImageData(out, width, height);
    }

    function removeIsolatedPixels(imageData) {
      const { width, height, data } = imageData;
      const out = new Uint8ClampedArray(data.length);
      out.set(data);
      for (let y = 1; y < height - 1; y++) {
        for (let x = 1; x < width - 1; x++) {
          const idx = (y * width + x) * 4;
          if (data[idx] !== 0) continue;
          // Zähle schwarze 8-Nachbarn
          let n = 0;
          for (let dy = -1; dy <= 1; dy++) {
            for (let dx = -1; dx <= 1; dx++) {
              if (dx === 0 && dy === 0) continue;
              if (data[((y + dy) * width + (x + dx)) * 4] === 0) n++;
            }
          }
          if (n < 2) { // einsam oder fast einsam → weiß setzen
            out[idx] = out[idx + 1] = out[idx + 2] = 255;
          }
        }
      }
      return new ImageData(out, width, height);
    }

    function thickenLines(imageData, radius) {
      const { width, height, data } = imageData;
      const out = new Uint8ClampedArray(data.length);
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          let isBlack = false;
          for (let dy = -radius; dy <= radius && !isBlack; dy++) {
            for (let dx = -radius; dx <= radius && !isBlack; dx++) {
              const nx = x + dx, ny = y + dy;
              if (nx >= 0 && nx < width && ny >= 0 && ny < height) {
                if (data[(ny * width + nx) * 4] === 0) isBlack = true;
              }
            }
          }
          const idx = (y * width + x) * 4;
          const v = isBlack ? 0 : 255;
          out[idx] = out[idx + 1] = out[idx + 2] = v;
          out[idx + 3] = 255;
        }
      }
      return new ImageData(out, width, height);
    }

    function downloadPdf() {
      if (!hasResult) { showMessage('Erstelle zuerst ein Ausmalbild.', 'error'); return; }
      if (!window.jspdf || !window.jspdf.jsPDF) {
        showMessage('PDF-Bibliothek konnte nicht geladen werden. Bitte Seite neu laden.', 'error');
        return;
      }
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageW = 210, pageH = 297, margin = 12, brandReserve = 10;
      const maxW = pageW - margin * 2;
      const maxH = pageH - margin * 2 - brandReserve;
      const canvas = els.result;
      const imgData = canvas.toDataURL('image/png');
      const ratio = canvas.width / canvas.height;
      let drawW = maxW, drawH = drawW / ratio;
      if (drawH > maxH) { drawH = maxH; drawW = drawH * ratio; }
      const offsetX = (pageW - drawW) / 2;
      const offsetY = (pageH - brandReserve - drawH) / 2;
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, pageW, pageH, 'F');
      pdf.addImage(imgData, 'PNG', offsetX, offsetY, drawW, drawH);
      const cfg = window.tpColoringConfig || {};
      if (cfg.showBranding && cfg.brandingText) {
        pdf.setFontSize(9);
        pdf.setTextColor(150);
        pdf.text(cfg.brandingText, pageW / 2, pageH - 6, { align: 'center' });
      }
      pdf.save('ausmalbild.pdf');
    }

    function resetGenerator() {
      originalImage = null; hasResult = false;
      dragDepth = 0;
      setDragState(false);
      els.upload.value = '';
      els.detail.value = 50; els.detailVal.textContent = '50';
      els.original.getContext('2d').clearRect(0, 0, els.original.width, els.original.height);
      els.result.getContext('2d').clearRect(0, 0, els.result.width, els.result.height);
      els.workspace.hidden = true;
      els.downloadBtn.disabled = true;
      clearMessage();
    }
  }

  function boot() {
    const roots = document.querySelectorAll('[data-coloring-generator]');
    if (!roots.length) return;

    // Außerhalb der Generatoren Browser-Default (Bild im Tab öffnen) unterdrücken
    ['dragover', 'drop'].forEach((type) => {
      window.addEventListener(type, (e) => {
        const inZone = Array.prototype.some.call(roots, (r) => r.contains(e.target));
        if (!inZone) e.preventDefault();
      });
    });

    roots.forEach(initColoringGenerator);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();